import React from "react";

import { useQuery, gql } from "@apollo/client";

import RbAutocompleteAsyncField from "components/RbAutocompleteAsyncField";
import useDebounce from "hooks/useDebounce";

const manufacturerQuery = gql`
  query manufacturerList($contains: String) {
    manufacturerList(
      filter: { name: { contains: $contains } }
      pagination: { limit: 5 }
    ) {
      edges {
        id
        name
      }
    }
  }
`;

const ManufacturerAutocomplete = (props) => {
  const [filter, setFilter] = React.useState("");

  const debouncedFilter = useDebounce(filter, 500);

  const {
    data: { manufacturerList: { edges = [] } = {} } = {},
    loading,
  } = useQuery(manufacturerQuery, {
    variables: {
      contains: debouncedFilter,
    },
  });

  return (
    <RbAutocompleteAsyncField
      filter={filter}
      onFilter={setFilter}
      loading={loading}
      options={loading ? [] : edges}
      {...props}
    />
  );
};

export default React.memo(ManufacturerAutocomplete);
